import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { showErrorDialog, showSuccessSnackbar } from 'src/app/shared/utils';
import { environment } from 'src/environments/environment';
import { UKComplianceManualItem } from './uk-compliance-manual.model';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class UkComplianceManualService {
  private apiEndpoint = `${environment.apiEndpoint}/api/uk/compliance-manual`;

  constructor(
    private http: HttpClient,
    private logger: NGXLogger,
    public apiErrorDialog: MatDialog,
    private snackBar: MatSnackBar
  ) {}

  getMine$(): Observable<UKComplianceManualItem | null> {
    return this.http.get<UKComplianceManualItem>(`${this.apiEndpoint}/me`).pipe(catchError(() => of(null)));
  }

  acknowledge$(readingTimeMs: number): Observable<void> {
    return this.http
      .post(`${this.apiEndpoint}/ack`, null, {
        params: {
          readingTimeMs: readingTimeMs.toString()
        },
        responseType: 'text'
      })
      .pipe(
        map(() => showSuccessSnackbar(this.snackBar, 'Your acknowledgement was successfully recorded')),
        catchError((error: any) => {
          this.logger.error(error);
          showErrorDialog(this.apiErrorDialog, error);
          return throwError(() => new Error(error));
        })
      );
  }
}
